import classNames from 'classnames';
import Button from 'components/ui/Button';
import Text from 'components/ui/Text';
import { ContactFormModalTrigger } from 'compositions/ContactFormModal';
import { useTranslation } from 'hooks/useTranslation';
import Image from 'next/image';
import { FC } from 'react';

type CtaBlockType = {
  title?: string;
  text?: string;
};

const CtaBlock: FC<CtaBlockType> = ({ title, text }) => {
  const translation = useTranslation();

  const commonClasses = 'col-span-6 rounded-md overflow-hidden';

  return (
    <div className="grid grid-cols-6 md:grid-flow-col-dense md:grid-cols-12 w-full gap-3">
      <div className={classNames(commonClasses, 'col-start-1 md:col-start-7')}>
        <Image
          width={700}
          height={700}
          className="aspect-square object-cover"
          src="/media/Fagerhult_Kvisten.jpg"
          alt=""
        />
      </div>
      <div
        className={classNames(
          commonClasses,
          'bg-grey-200 p-8 flex flex-col justify-between',
        )}
      >
        <Text elementType="h2" size="xlarge" className="!font-bold">
          {title}
        </Text>
        <div className="flex flex-col gap-6">
          <p className="text-sm leading-[1.2] mb-0">{text}</p>
          <div className="flex flex-row gap-2">
            <Button
              target="_blank"
              style="transparentOutline"
              className=""
              url={translation('links.products')}
            >
              {translation('recipe.findProducts')}
            </Button>
            <ContactFormModalTrigger
              trigger={{
                type: 'button',
                text: translation('general.getInTouch'),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaBlock;
